import Pusher from 'pusher-js'

const {REACT_APP_PUSHER_APP_KEY: key, REACT_APP_PUSHER_CLUSTER: cluster } = process.env
const token = JSON.parse(localStorage.getItem("authUser"))?.token;
let baseURL = process.env.REACT_APP_API_URL;

let pusher = null;
if (token && key && cluster) {
  try {
    pusher = new Pusher(key, {
      cluster,
      userAuthentication: {
        endpoint: baseURL+'/auth/pusher-user',
        headers: {
          Authorization:`Bearer ${token}`
        }
      },
      autoReconnect: true,
      maxReconnectAttempts: 10,
      timeout: 30000
    })
    pusher.signin()
  } catch (_e) {
    console.error('Failed to authenticate pusher user.')
  }
}

export default pusher
